// src/App.js
// src/index.js
import 'bootstrap/dist/css/bootstrap.min.css';
// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Prospectos from './components/Prospectos';
import Clientes from './components/Clientes';
import Pedido from './components/Pedido';
import Productos from './components/Productos';
import BottomNavigation from './components/BottomNavigation';

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/prospectos" element={<Prospectos />} />
          <Route path="/clientes" element={<Clientes />} />
          <Route path="/pedido" element={<Pedido />} />
          <Route path="/productos" element={<Productos />} />
        </Routes>
        <BottomNavigation />
      </div>
    </Router>
  );
};

export default App;

